class MainBlog extends HTMLElement {
    constructor() {
      super();
      this.onBtnClick = this.onBtnClick.bind(this);
      this.onShowAllClick = this.onShowAllClick.bind(this);
      this.limit = 9;
      this.showingAll = false;
    }
    
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.blc__btn'));
      this.items = Array.from(this.querySelectorAll('.blc-item'));
      this.cta = this.querySelector('.blc__cta');
      this.showAllBtn = this.querySelector('#blc-show-all');
      if (this.showAllBtn) this.showAllBtn.addEventListener('click', this.onShowAllClick);
      if (!(this.buttons.length && this.items.length)) return;
      this.buttons.forEach(b => b.addEventListener('click', this.onBtnClick));
      const urlTag = new URL(window.location).searchParams.get('tag') || '';
      const initial = this.buttons.find(b => (b.getAttribute('data-tag') || '') === urlTag) || this.buttons[0];
      this.setActive(initial);
      this.applyFilter(initial.getAttribute('data-tag') || '');
    }

    disconnectedCallback() {
      if (this.buttons) this.buttons.forEach(b => b.removeEventListener('click', this.onBtnClick));
      if (this.showAllBtn) this.showAllBtn.removeEventListener('click', this.onShowAllClick);
    }

    onBtnClick(e) {
      const btn = e.currentTarget;
      if (btn.id === 'blc-show-all') return;
      const tag = btn.getAttribute('data-tag') || '';
      this.setActive(btn);
      this.showingAll = false;
      this.applyFilter(tag);
      const url = new URL(window.location);
      if (tag) url.searchParams.set('tag', tag); else url.searchParams.delete('tag');
      window.history.replaceState({}, '', url);
    }

    onShowAllClick() {
      this.showingAll = !this.showingAll;
      const active = this.buttons.find(b => b.classList.contains('is-active')) || this.buttons[0];
      const tag = active ? (active.getAttribute('data-tag') || '') : '';
      this.applyFilter(tag);
    }
    
      
    setActive(btn) {
      this.buttons.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    }

    applyFilter(tag) {
      this.items.forEach(item => {
        const list = (item.getAttribute('data-tags') || '').split(/\s+/).filter(Boolean);
        const show = !tag || list.includes(tag);
        item.classList.toggle('is-hidden', !show);
      });
      this.applyLimit();
    }

    applyFilter(tag) {
      const matched = [];
    
      this.items.forEach(item => {
        const list = (item.getAttribute('data-tags') || '')
          .split(/\s+/)
          .filter(Boolean);
    
        const ok = !tag || list.includes(tag);
        item.classList.toggle('is-hidden', !ok);
    
        item.classList.remove('is-truncated');
    
        if (ok) matched.push(item);
      });
    
      this.applyLimit(matched);
    }
    
    applyLimit(matchedItems) {
      const matched = matchedItems || [];
    
      const hasMore = matched.length > this.limit;
    
      if (this.cta) {
        this.cta.classList.toggle('is-hidden', !hasMore);
      }
    
      if (!hasMore) {
        this.showingAll = false;
        if (this.showAllBtn) {
          this.showAllBtn.textContent = 'Voir plus';
          this.showAllBtn.setAttribute('aria-expanded', 'false');
        }
        return;
      }
    
      if (!this.showingAll) {
        matched.forEach((el, idx) => el.classList.toggle('is-truncated', idx >= this.limit));
      } else {
        matched.forEach(el => el.classList.remove('is-truncated'));
      }
    
      if (this.showAllBtn) {
        this.showAllBtn.textContent = this.showingAll ? 'Voir moins' : 'Voir plus';
        this.showAllBtn.setAttribute('aria-expanded', this.showingAll ? 'true' : 'false');
      }
    }
    
    
      
  }
  customElements.define('main-blog', MainBlog);
  